module.exports = __webpack_public_path__ + "img/flag-de.79a01634.svg";